import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { NotesCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandsDefaultLabels, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

@Component({
    selector: 'st-notes-command-dialog',
    templateUrl: './notes-command-dialog.html',
    styleUrls: ['./notes-command-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-notes-command-dialog' },
})
export class NotesCommandDialogComponent {
    public ProductionFieldName = ProductionFieldName;
    public ProductionCommandsDefaultLabels = ProductionCommandsDefaultLabels;
    public command = input<NotesCommand>();
    public commandChange = output<NotesCommand>();
    public onEnterEmitter = output<NotesCommand>();

    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            this.commandChange.emit(this.command());
        }
    }

    public onEnterSaveCommand(event: any) {
        this.onCommandsObjectChange(event, ProductionFieldName.NOTES);
        this.onEnterEmitter.emit(this.command());
    }
}
